import { Project } from "./types";
import pbShowcase from "../assets/pb-showcase-mobile.webp";
import reactIcon from "../assets/react-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import sassIcon from "../assets/sass-icon.svg";

export const panoramaBogensportProject: Project = {
  title: "Panorama Bogensport",
  description:
    "This was the first Website I ever made. At first I made it with Wordpress, but that was too slow for my taste. So I decided to remake the website with React and TypeScript. I learned a lot about SEO, performance and how to make a website fast and responsive. I also added the option to choose english or german as the language of the website.",
  date: "08/2023 - 02/2024",
  image: pbShowcase,
  imageAlt: "Panorama Bogensport website showcase",
  link: "https://panorama-bogensport.at/",
  technologies: [reactIcon, typescriptIcon, sassIcon],
};
